import { useSelector } from "react-redux";
import ForgotPasswordPage from "../../components/PublicLayout/ForgotPasswordPage/ForgotPasswordPage";
import LoginPage from "../../components/PublicLayout/LoginPage/LoginPage";
import RegistrationPage from "../../components/PublicLayout/RegistrationPage/RegistrationPage";
import LoginPageSSO from "../../components/PublicLayout/SSO/LoginPageSSO";
import PrivacyPolicy from "../../features/common/TerminiCondizioniPage/PrivacyPolicy";
import TerminiCondizioniPage from "../../features/common/TerminiCondizioniPage/TerminiCondizioniPage";

const usePublicRoutes = () => {
  const appConfig = useSelector((state) => state.app.appConfig);

  return [
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/registration",
      element: <RegistrationPage />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      path: "/",
      element: <LoginPage />,
    },
    {
      path: "/termini-e-condizioni",
      element: <TerminiCondizioniPage />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    ...(appConfig?.modules?.login?.SSO
      ? [
          {
            path: "/access-sso",
            element: <LoginPageSSO />,
          },
        ]
      : []),
  ];
};

export default usePublicRoutes;
